// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UIZDW","rootMobile":"styles_rootMobile__2eR4o"};